import Filters from './Filters';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from '../../actions';

const mapStateToProps = state => {
  const { selectedFields, filters } = state.reports;

  const fields = selectedFields.map(field => ({
    value: field.id,
    label: field.name
  }));

  return { fields, filters };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Filters);



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/Filters/FiltersContainer.js